import _ from 'lodash'
import formHelper from 'scoreboard/components/form-helper'

function changeHandler (view, renderChangeEvents) {
	var model = view.model
	view.listenTo(model, 'change:dirty', function() {
		//re-render if form dirty form is reset
		if (!model.get('dirty')) {
			view.render()
		}
	}.bind(view))

	//apply re-render on certain property changes if specified
	if (renderChangeEvents) {
		var evts = renderChangeEvents
		if (_.isArrayLikeObject(renderChangeEvents)) {
			evts = _(renderChangeEvents).map(function (v) {return 'change:'+v}).join(' ')
		}
		view.listenTo(model, evts, function() {
			view.render()
		}.bind(view))
	}

	// //propagate any .report-info changes on view to report model
	view.on('change', function() {
		if (view.label) {
			model.set('label', view.label.val())
		}
		//only read from the .report-info, views (e.g. chart form) have internal
		//logic handling changes from panels other than the basic report info panel
		model.set(formHelper.readFromDom(view.$('.report-info')))
	}.bind(view))
}


export const listenToChanges = changeHandler
